import React from "react";

import "./ChartIcons.scss";

const MultiYPlot = props => {
  const getClassName = () => {
    const styleClass = "chart-icon";
    return props.active && !props.disabled ? `${styleClass}-active` : styleClass;
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" className={getClassName()} disabled={props.disabled}>
      <g id="Multi_Y" data-name="Multi Y" transform="translate(0.5 0.5)">
        <g id="Group_15140" data-name="Group 15140">
          <path id="margin" fill="#fff" stroke="#707070" opacity="0" d="M0 0H32V32H0Z" />
          <path
            id="Path_12998"
            data-name="Path 12998"
            className="icon-fill"
            d="M20.5 12.4l1.336 1.336-2.847 2.847-2.333-2.334-4.323 4.329.823.822 3.5-3.5 2.333 2.333 3.675-3.669L24 15.9V12.4Z"
          />
          <line
            id="Line_306"
            data-name="Line 306"
            fill="none"
            className="icon-stroke"
            strokeLinecap="square"
            strokeMiterlimit="10"
            y2="16"
            transform="translate(8 7.9)"
          />
          <line
            id="Line_307"
            data-name="Line 307"
            fill="none"
            className="icon-stroke"
            strokeLinecap="square"
            strokeMiterlimit="10"
            y2="16"
            transform="translate(10.701 7.9)"
          />
        </g>
      </g>
    </svg>
  );
};

export default MultiYPlot;
